// Generated by purs version 0.15.0
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Set_Serialized from "../Data.Set.Serialized/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Coupons_Internal_Types_CouponData from "../Restaumatic.Coupons.Internal.Types.CouponData/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var UserLoyalty = function (x) {
    return x;
};
var eqUserLoyalty = {
    eq: function (x) {
        return function (y) {
            return x.count === y.count && Data_Eq.eq(Data_Set_Serialized.eqSet(Restaumatic_Coupons_Internal_Types_CouponData.eqCouponData))(x.couponData)(y.couponData) && x.promotionName === y.promotionName;
        };
    }
};
var newtypeUserLoyalty = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldUserLoyalty = function (dictHasField) {
    return dictHasField;
};
var genericUserLoyalty = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showUserLoyalty = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericUserLoyalty)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "count";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "couponData";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "promotionName";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showString))(/* #__PURE__ */ Data_Set_Serialized.showSet(Restaumatic_Coupons_Internal_Types_CouponData.showCouponData)))(Data_Show.showInt))))({
        reflectSymbol: function () {
            return "UserLoyalty";
        }
    }))
};
var unscrambleDecodeUserLoyalty = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericUserLoyalty)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "count";
        }
    })(Unscramble.decodeInt1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "couponData";
        }
    })(/* #__PURE__ */ Data_Set_Serialized.udecodeSet(Restaumatic_Coupons_Internal_Types_CouponData.ordCouponData)(Restaumatic_Coupons_Internal_Types_CouponData.unscrambleDecodeCouponData))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "promotionName";
        }
    })(Unscramble.decodeString1)(Unscramble.decodeRecordNil)))))))(Unscramble_Generic.defaultOptions)
};
var encodingOpts = /* #__PURE__ */ (function () {
    return {
        sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
        unwrapSingleConstructors: true,
        unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
        unwrapSingleRecordArguments: true,
        fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform
    };
})();
var encodeUserLoyalty = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericUserLoyalty)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "UserLoyalty";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "promotionName";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "couponData";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Data_Set_Serialized.encodeSet(Restaumatic_Coupons_Internal_Types_CouponData.encodeCouponData))))({
        reflectSymbol: function () {
            return "count";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode))))))(encodingOpts)
};
var decodeUserLoyalty = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericUserLoyalty)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "UserLoyalty";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "promotionName";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "couponData";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Data_Set_Serialized.decodeSet(Restaumatic_Coupons_Internal_Types_CouponData.ordCouponData)(Restaumatic_Coupons_Internal_Types_CouponData.decodeCouponData)))())({
        reflectSymbol: function () {
            return "count";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
export {
    UserLoyalty,
    encodingOpts,
    genericUserLoyalty,
    showUserLoyalty,
    eqUserLoyalty,
    decodeUserLoyalty,
    unscrambleDecodeUserLoyalty,
    encodeUserLoyalty,
    newtypeUserLoyalty,
    hasFieldUserLoyalty
};
//# sourceMappingURL=index.js.map
